import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

window.hljs = hljs;
